import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4912d03e")

_pushScopeId("data-v-4912d03e")
const _hoisted_1 = { class: "content-container-div" }
const _hoisted_2 = { class: "content-container-div-inner" }
const _hoisted_3 = { class: "actions-column" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_HeldButton = _resolveComponent("HeldButton")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.visibleNotes,
    lazy: true,
    paginator: true,
    rows: _ctx.pageSize,
    loading: _ctx.loading,
    globalFilterFields: [_ctx.NAME, _ctx.ID, _ctx.CONTENT_TEXT, _ctx.CREATION_TIME, _ctx.LAST_MODIFIED_TIME],
    totalRecords: _ctx.totalNoteCount,
    filters: _ctx.filters,
    "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
    ref: "dt",
    filterDisplay: "row",
    responsiveLayout: "scroll",
    onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
    onSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSort($event)))
  }, {
    default: _withId(() => [
      _createVNode(_component_Column, {
        header: "Name",
        class: "base-column",
        filterMatchMode: "startsWith",
        field: _ctx.NAME,
        ref: _ctx.NAME,
        sortable: true
      }, {
        filter: _withId(({filterModel,filterCallback}) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter filter-input --text-input",
            placeholder: "Search by name"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }, 8, ["field"]),
      _createVNode(_component_Column, {
        header: "Content",
        class: "base-column",
        filterMatchMode: "contains",
        field: _ctx.CONTENT_TEXT,
        filterField: _ctx.CONTENT_TEXT,
        ref: _ctx.CONTENT_TEXT,
        sortable: true
      }, {
        filter: _withId(({filterModel,filterCallback}) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter filter-input --text-input",
            placeholder: "Search by content"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        body: _withId((slotProps) => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              (!!slotProps.data[_ctx.CONTENT_TEXT])
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(slotProps.data[_ctx.CONTENT_TEXT]), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Fetch content",
                    onClick: ($event: any) => (_ctx.onFetchContentClick(slotProps.data))
                  }, null, 8, ["onClick"]))
            ])
          ])
        ]),
        _: 1
      }, 8, ["field", "filterField"]),
      _createVNode(_component_Column, {
        header: "Created",
        class: "base-column",
        dataType: "date",
        filterMatchMode: "dateAfter",
        field: _ctx.CREATION_TIME,
        filterField: _ctx.CREATION_TIME,
        ref: _ctx.CREATION_TIME,
        sortable: true
      }, {
        filter: _withId(({filterModel,filterCallback}) => [
          _createVNode(_component_InputText, {
            type: "date",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter filter-input --date-input",
            placeholder: "Search by creation time"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        body: _withId((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data[_ctx.CREATION_TIME])), 1)
        ]),
        _: 1
      }, 8, ["field", "filterField"]),
      _createVNode(_component_Column, {
        header: "Modified",
        class: "base-column",
        dataType: "date",
        filterMatchMode: "dateAfter",
        field: _ctx.LAST_MODIFIED_TIME,
        filterField: _ctx.LAST_MODIFIED_TIME,
        ref: _ctx.LAST_MODIFIED_TIME,
        sortable: true
      }, {
        filter: _withId(({filterModel,filterCallback}) => [
          _createVNode(_component_InputText, {
            type: "date",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter filter-input --date-input",
            placeholder: "Search by modification time"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        body: _withId((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data[_ctx.LAST_MODIFIED_TIME])), 1)
        ]),
        _: 1
      }, 8, ["field", "filterField"]),
      _createVNode(_component_Column, {
        header: "Actions",
        class: "base-column",
        sortable: false
      }, {
        body: _withId((slotProps) => [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_Button, {
              label: "Restore",
              class: _ctx.restoreButtonClass,
              icon: "pi pi-refresh",
              onClick: ($event: any) => (_ctx.onRestoreNoteClick($event, slotProps.data))
            }, null, 8, ["class", "onClick"]),
            _createVNode(_component_HeldButton, {
              label: "Delete",
              class: "action-button --delete",
              loadedIconToUse: _ctx.deleteButtonIcon,
              onClick: ($event: any) => (_ctx.onDeleteClick($event, slotProps.data))
            }, null, 8, ["loadedIconToUse", "onClick"])
          ])
        ]),
        default: _withId(() => [
          _createVNode(_component_ConfirmPopup)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "rows", "loading", "globalFilterFields", "totalRecords", "filters"]))
})